<template src="./../views/MenuBar.pug" lang="pug">
</template>

<script>
  export default {
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
      };
    },
  };
</script>



// WEBPACK FOOTER //
// MenuBar.vue?757e53ae